import React from 'react';

import './SearchBarContainer.sass';

import {injectIntl} from 'react-intl';
import {browserHistory, withRouter} from 'react-router';
import debounce from 'lodash-es/debounce';

import cx from 'classnames';
import withChannelFormatters from '../channelUtils/withChannelFormatters';

@injectIntl
@withChannelFormatters
@withRouter
export default class SearchBarContainer extends React.PureComponent {
  constructor(props) {
    super(props);

    const {location} = props;

    let searchQuery = '';
    if (location.pathname.indexOf('/search') !== -1) {
      searchQuery = location.query.q;
    }

    this.state = {searchQuery};
  }

  executeSearch = () => {
    const {onSearch, channelFormatters} = this.props;
    const {searchQuery} = this.state;

    if (!searchQuery) {
      return;
    }

    browserHistory.push(channelFormatters.link(`/search?q=${this.state.searchQuery}`));

    onSearch && onSearch();
  };

  debouncedExecuteSearch = debounce(this.executeSearch, 500);

  handleSearchChange = (e) => {
    const {manual} = this.props;

    this.setState({searchQuery: e.target.value});

    if (!manual) {
      this.debouncedExecuteSearch();
    }
  };

  handleKeyPress = (e) => {
    this.debouncedExecuteSearch.cancel();

    if (e.key === 'Enter') {
      this.executeSearch();
    }
  };

  clearInput = () => {
    this.setState({searchQuery: ''});
  };

  componentWillReceiveProps(nextProps) {
    const {location} = this.props;

    if (location.pathname.indexOf('/search') !== -1) {
      this.setState({searchQuery: location.query.q});
    }
  }

  componentWillUnmount() {
    const {manual} = this.props;

    if (manual) {
      this.executeSearch();
    }
  }

  render() {
    const {searchQuery} = this.state;
    const {intl} = this.props;

    return (
      <div className={cx('search-bar')}>
        <input
          type="text"
          className="search-bar__input"
          value={searchQuery}
          onChange={this.handleSearchChange}
          onKeyPress={this.handleKeyPress}
          placeholder={intl.formatMessage({id: 'section.search'})}
          maxLength="64"
          required
        />

        <button
          onClick={this.clearInput}
          className="search-bar__clear"
        />

        <span className="search-bar__icon"/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./containers/searchBarContainer/SearchBarContainer.js